import { useInvalidateQueries } from '@partful/shared/lib/hooks/useInvalidateQueries';
import { useProductInventory } from '@partful/shared/lib/hooks/useProductInventory';
import {
  productInventoryEndpoints,
  type PartCategoriesStatusOptions,
  type PATCHPartCategoriesJobResponse,
  type ProcessingJobError,
} from '@services/productInventory';
import { useMutation } from '@tanstack/react-query';

export interface UseUpdatePartCategoriesJobVars {
  runID: string;
  accountId: string;
  status?: PartCategoriesStatusOptions;
  errors?: ProcessingJobError[];
}

export const useUpdatePartCategoriesJob = () => {
  const { invalidateContentProcessingJobsQueries, invalidatePartCategoriesJobQuery, invalidatePartTreeQuery } =
    useInvalidateQueries();

  const { getService } = useProductInventory();

  return useMutation<PATCHPartCategoriesJobResponse, Error, UseUpdatePartCategoriesJobVars>({
    mutationFn: async ({ runID, accountId, status, errors }) => {
      const productInventoryService = await getService();

      return (
        await productInventoryService.patch(
          `${productInventoryEndpoints.contentProcessing.partsCategories}/${runID}?account=${accountId}`,
          { status, errors }
        )
      ).data.payload;
    },
    onSuccess: async () => {
      await Promise.all([
        invalidateContentProcessingJobsQueries(),
        invalidatePartCategoriesJobQuery(),
        invalidatePartTreeQuery(),
      ]);
    },
  });
};
